import { render, staticRenderFns } from "./HeadNotice.vue?vue&type=template&id=547b606e&"
import script from "./HeadNotice.vue?vue&type=script&lang=js&"
export * from "./HeadNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports